const EMAIL = "contact@tubeoptimizer.net";
const LOCATION = "Wyoming, États-Unis";
const DATE = "20 septembre 2026";

const fr = {
  nav: [
    { label: "Accueil", path: "/", testId: "nav-link-home" },
    { label: "À propos", path: "/about", testId: "nav-link-about" },
    { label: "Applications", path: "/apps", testId: "nav-link-apps" },
    { label: "Contact", path: "/contact", testId: "nav-link-contact" },
  ],
  header: { cta: "Nos applications", language: "Langue" },
  footer: {
    blurb: "Nous concevons et publions des applications mobiles. Société enregistrée dans l'État du Wyoming, États-Unis.",
    contact: "Contact",
    legal: "Informations légales",
    privacy: "Politique de confidentialité",
    terms: "Conditions d'utilisation",
    copyright: "© 2026 TubeOptimizer LLC. Tous droits réservés.",
    location: "Wyoming · États-Unis",
  },
  marquee: ["Applications mobiles", "Simplicité", "Confidentialité", "Sécurité des utilisateurs", "Qualité", "Wyoming, États-Unis"],
  device: { tag1Label: "Principe", tag1Value: "Vie privée par défaut", tag2Label: "Plateformes", tag2Value: "iOS · Android" },
  legal: { lastUpdated: "Dernière mise à jour" },

  home: {
    meta: {
      title: "TubeOptimizer LLC — Nous concevons et publions des applications mobiles",
      description: "TubeOptimizer LLC est une société américaine (Wyoming, États-Unis) qui conçoit et publie des applications mobiles simples, sûres et utiles.",
    },
    eyebrow: "Éditeur d'applications mobiles",
    taglineLines: ["Nous concevons et publions", "des applications mobiles."],
    description:
      "TubeOptimizer LLC est une société qui développe des applications mobiles pensées pour être simples à utiliser, respectueuses de la vie privée et réellement utiles au quotidien.",
    ctaApps: "Découvrir nos applications",
    ctaAbout: "En savoir plus",
    approachEyebrow: "Notre approche",
    approachTitle: "Trois principes qui guident chacune de nos applications.",
    chapters: [
      { n: "01", title: "Simplicité", text: "Des interfaces claires, sans superflu, où chaque écran a une raison d'être et chaque geste un objectif précis." },
      { n: "02", title: "Sécurité et vie privée", text: "La protection des utilisateurs et de leurs données guide chacune de nos décisions, de la conception jusqu'à la publication." },
      { n: "03", title: "Utilité et qualité", text: "Nous ne publions que des applications réellement utiles, testées avec soin et maintenues dans la durée." },
    ],
    ctaSection: {
      eyebrow: "Applications",
      title: "Nos premières applications sont en cours de développement.",
      text: "Elles seront annoncées sur la page Applications dès leur publication.",
      button: "Voir la page Applications",
    },
  },

  about: {
    meta: {
      title: "À propos — TubeOptimizer LLC",
      description: "TubeOptimizer LLC est une société enregistrée aux États-Unis (Wyoming), fondée en 2026, dédiée à la création d'applications mobiles simples, sûres et utiles.",
    },
    eyebrow: "À propos",
    title: "Une société américaine dédiée aux applications mobiles.",
    subtitle: "Qui nous sommes, ce que nous cherchons à construire et la manière dont nous travaillons.",
    who: {
      title: "Qui sommes-nous",
      text: "TubeOptimizer LLC est une société enregistrée aux États-Unis, dans l'État du Wyoming, fondée en 2026. Nous développons et publions des applications mobiles destinées au grand public.",
      facts: [
        { label: "Forme", value: "LLC" },
        { label: "Enregistrement", value: LOCATION },
        { label: "Fondation", value: "2026" },
      ],
    },
    mission: {
      title: "Notre mission",
      lead: "Concevoir des applications mobiles simples, sûres et utiles.",
      text: "Nous croyons que les meilleures applications sont celles qui font une chose bien, sans distraire ni compliquer. Nous privilégions la clarté, le respect des utilisateurs et une qualité constante plutôt que la multiplication des fonctionnalités.",
    },
    how: {
      title: "Comment nous travaillons",
      principles: [
        { title: "Vie privée", text: "Nous limitons la collecte de données au strict nécessaire et nous expliquons clairement ce que nos applications font." },
        { title: "Sécurité des utilisateurs", text: "Nous appliquons les bonnes pratiques de sécurité mobile et nous corrigeons rapidement tout problème identifié." },
        { title: "Qualité", text: "Chaque application est testée avec soin avant publication, puis maintenue et améliorée dans la durée." },
      ],
    },
  },

  apps: {
    meta: {
      title: "Applications — TubeOptimizer LLC",
      description: "Les applications mobiles publiées par TubeOptimizer LLC. Nos premières applications sont en cours de développement et seront annoncées ici prochainement.",
    },
    eyebrow: "Applications",
    title: "Nos applications mobiles.",
    subtitle: "Les applications que nous concevons et publions seront présentées sur cette page.",
    badge: "En développement",
    message: "Nos premières applications sont actuellement en cours de développement et seront annoncées ici prochainement.",
    placeholder: "Application à venir ·",
  },

  contact: {
    meta: {
      title: "Contact — TubeOptimizer LLC",
      description: `Contactez TubeOptimizer LLC par courriel à ${EMAIL}. Nous répondons généralement sous 2 jours ouvrés.`,
    },
    eyebrow: "Contact",
    title: "Écrivez-nous.",
    subtitle: "Pour toute question concernant la société ou nos applications, contactez-nous par courriel.",
    companyLabel: "Société",
    location: LOCATION,
    emailLabel: "Courriel",
    responseLabel: "Délai de réponse",
    responseTime: "Nous répondons généralement sous 2 jours ouvrés.",
  },

  privacy: {
    meta: {
      title: "Politique de confidentialité — TubeOptimizer LLC",
      description: "Politique de confidentialité du site web de TubeOptimizer LLC : données des visiteurs, courriels de contact, cookies, sécurité et droits des utilisateurs.",
    },
    eyebrow: "Informations légales",
    title: "Politique de confidentialité",
    lastUpdated: DATE,
    sections: [
      {
        id: "introduction",
        title: "Introduction",
        paragraphs: [
          "La présente politique de confidentialité décrit la manière dont TubeOptimizer LLC (« nous ») traite les informations relatives aux visiteurs de ce site web et aux personnes qui nous contactent. Elle s'applique au site web de la société. Les applications mobiles que nous publions peuvent disposer de leur propre politique de confidentialité, accessible depuis l'application ou sa fiche de téléchargement.",
        ],
      },
      {
        id: "visiteurs",
        title: "Visiteurs du site web",
        paragraphs: [
          "Ce site est un site d'information statique. Il ne comporte ni compte utilisateur, ni formulaire, ni base de données. Nous ne collectons pas volontairement de données personnelles lors de la simple consultation des pages.",
          "Comme pour tout site web, l'hébergeur peut enregistrer des informations techniques nécessaires au fonctionnement et à la sécurité du service (adresse IP, type de navigateur, pages consultées, date et heure de la requête). Ces informations ne sont utilisées que pour assurer la disponibilité et la sécurité du site.",
        ],
      },
      {
        id: "courriels",
        title: "Courriels de contact",
        paragraphs: [
          `Lorsque vous nous écrivez à l'adresse ${EMAIL}, nous recevons votre adresse électronique ainsi que le contenu de votre message. Ces informations sont utilisées uniquement pour répondre à votre demande et en assurer le suivi.`,
          "Nous conservons les échanges pendant la durée nécessaire au traitement de la demande, puis pour la durée requise par nos obligations légales éventuelles. Nous ne vendons ni ne partageons ces informations avec des tiers à des fins commerciales.",
        ],
      },
      {
        id: "cookies",
        title: "Cookies",
        paragraphs: [
          "Ce site n'utilise pas de cookies publicitaires et ne dépose pas de traceurs à des fins de profilage. Le site mémorise uniquement, dans votre navigateur, votre préférence de langue (français ou anglais) afin de vous la proposer lors de votre prochaine visite. Cette information reste sur votre appareil et ne nous est pas transmise.",
          "Si des cookies strictement nécessaires au fonctionnement technique du site ou des outils de mesure d'audience étaient utilisés à l'avenir, cette politique serait mise à jour en conséquence. Vous pouvez à tout moment configurer votre navigateur pour refuser ou supprimer les cookies et les données de site.",
        ],
      },
      {
        id: "securite",
        title: "Sécurité des données",
        paragraphs: [
          "Nous mettons en œuvre des mesures techniques et organisationnelles raisonnables afin de protéger les informations que nous traitons contre l'accès, la modification, la divulgation ou la destruction non autorisés. Le site est servi via une connexion chiffrée (HTTPS).",
        ],
      },
      {
        id: "droits",
        title: "Vos droits",
        paragraphs: [
          "Selon votre lieu de résidence, vous pouvez disposer de droits concernant vos données personnelles, notamment :",
          {
            list: [
              "le droit d'accéder aux informations que nous détenons à votre sujet ;",
              "le droit de demander leur rectification ou leur suppression ;",
              "le droit de vous opposer à un traitement ou d'en demander la limitation ;",
              "le droit d'introduire une réclamation auprès d'une autorité de contrôle compétente.",
            ],
          },
          "Pour exercer ces droits, contactez-nous à l'adresse indiquée ci-dessous. Nous pourrons vous demander de justifier votre identité avant de traiter votre demande.",
        ],
      },
      {
        id: "modifications",
        title: "Modifications",
        paragraphs: [
          "Nous pouvons mettre à jour cette politique de confidentialité pour refléter l'évolution de nos pratiques ou des exigences légales. La date de dernière mise à jour figure en haut de cette page. Nous vous invitons à la consulter régulièrement.",
        ],
      },
      {
        id: "contact",
        title: "Contact",
        paragraphs: ["Pour toute question relative à cette politique ou au traitement de vos données, vous pouvez nous écrire à :"],
        contact: true,
        address: true,
        location: LOCATION,
      },
    ],
  },

  terms: {
    meta: {
      title: "Conditions d'utilisation — TubeOptimizer LLC",
      description: "Conditions d'utilisation du site web de TubeOptimizer LLC : utilisation du site, propriété intellectuelle, limitation de responsabilité et droit applicable (Wyoming).",
    },
    eyebrow: "Informations légales",
    title: "Conditions d'utilisation",
    lastUpdated: DATE,
    sections: [
      {
        id: "acceptation",
        title: "Acceptation des conditions",
        paragraphs: [
          "En accédant à ce site web et en l'utilisant, vous acceptez les présentes conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser le site. Ce site est édité par TubeOptimizer LLC, société enregistrée dans l'État du Wyoming, États-Unis.",
        ],
      },
      {
        id: "utilisation",
        title: "Utilisation du site",
        paragraphs: [
          "Ce site a une vocation informative : il présente la société et les applications mobiles qu'elle conçoit et publie. Vous vous engagez à utiliser le site de manière licite et à ne pas :",
          {
            list: [
              "porter atteinte à son fonctionnement ou à sa sécurité ;",
              "tenter d'accéder sans autorisation à des systèmes ou données ;",
              "reproduire ou exploiter son contenu à des fins commerciales sans accord écrit préalable ;",
              "utiliser le site d'une manière contraire aux lois applicables.",
            ],
          },
          "Les applications mobiles publiées par TubeOptimizer LLC peuvent être soumises à des conditions d'utilisation spécifiques, disponibles depuis l'application ou sa fiche de téléchargement.",
        ],
      },
      {
        id: "propriete",
        title: "Propriété intellectuelle",
        paragraphs: [
          "L'ensemble des contenus du site (textes, noms, logos, éléments graphiques, mise en page et code) est la propriété de TubeOptimizer LLC ou fait l'objet d'une autorisation d'utilisation, et est protégé par les lois applicables en matière de propriété intellectuelle.",
          "Toute reproduction, représentation, modification ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite, à l'exception d'une consultation à titre personnel et non commercial.",
        ],
      },
      {
        id: "responsabilite",
        title: "Limitation de responsabilité",
        paragraphs: [
          "Le site est fourni « en l'état ». Nous nous efforçons de maintenir des informations exactes et à jour, sans toutefois garantir l'exhaustivité, l'exactitude ou la disponibilité permanente du site.",
          "Dans les limites permises par la loi, TubeOptimizer LLC ne saurait être tenue responsable des dommages directs ou indirects résultant de l'accès au site, de son utilisation ou de l'impossibilité d'y accéder. Le site peut contenir des liens vers des sites tiers dont nous ne contrôlons pas le contenu.",
        ],
      },
      {
        id: "modifications",
        title: "Modifications",
        paragraphs: [
          "Nous pouvons modifier les présentes conditions à tout moment. Les conditions applicables sont celles publiées sur le site au moment de votre consultation. La poursuite de l'utilisation du site après publication des modifications vaut acceptation de celles-ci.",
        ],
      },
      {
        id: "droit-applicable",
        title: "Droit applicable",
        paragraphs: [
          "Les présentes conditions sont régies par les lois de l'État du Wyoming, États-Unis, sans égard aux principes de conflits de lois. Tout litige relatif à l'utilisation du site relèvera de la compétence des tribunaux situés dans l'État du Wyoming, sous réserve des dispositions impératives applicables.",
        ],
      },
      {
        id: "contact",
        title: "Contact",
        paragraphs: ["Pour toute question concernant ces conditions d'utilisation :"],
        contact: true,
        location: LOCATION,
      },
    ],
  },
};

export default fr;
